(function () {
  function setState(wrapper, button, isPlaying, isMuted) {
    wrapper.setAttribute('data-playing', isPlaying ? 'true' : 'false');
    wrapper.setAttribute('data-muted', isMuted ? 'true' : 'false');
    var label = !isPlaying ? 'Play video' : isMuted ? 'Unmute video' : 'Pause video';
    button.setAttribute('aria-label', label);
  }

  function initWrapper(wrapper) {
    if (wrapper.dataset.videoToggleInit === 'true') return;
    wrapper.dataset.videoToggleInit = 'true';

    var media = wrapper.querySelector('video, iframe');
    var button = wrapper.querySelector('.brand-story__video-toggle');
    if (!media || !button) return;

    var type = 'html5';
    if (media.tagName === 'IFRAME') {
      type = media.src.indexOf('youtube') > -1 ? 'youtube' : 'vimeo';
    }

    var shouldAutoplay = wrapper.dataset.autoplay === 'true';
    var hasStarted = false;
    var userPaused = false;
    var pausedByObserver = false;
    var iframeMuted = true;

    function refreshHtml5State() {
      setState(wrapper, button, !media.paused, media.muted);
    }

    function play(unmute) {
      if (type === 'html5') {
        if (unmute) media.muted = false;
        media.play().catch(function () {
          // Browser blocked unmuted autoplay (no gesture) - fall back to muted playback.
          media.muted = true;
          media.play().catch(function () {});
        });
      } else if (type === 'youtube') {
        media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*');
        if (unmute) {
          media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
          iframeMuted = false;
        }
        setState(wrapper, button, true, iframeMuted);
      } else {
        media.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        if (unmute) {
          media.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 1 }), '*');
          iframeMuted = false;
        }
        setState(wrapper, button, true, iframeMuted);
      }
      hasStarted = true;
    }

    function pause() {
      if (type === 'html5') {
        media.pause();
      } else if (type === 'youtube') {
        media.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*');
        setState(wrapper, button, false, iframeMuted);
      } else {
        media.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        setState(wrapper, button, false, iframeMuted);
      }
    }

    if (type === 'html5') {
      media.pause();
      media.removeAttribute('autoplay');
      media.addEventListener('play', refreshHtml5State);
      media.addEventListener('pause', refreshHtml5State);
      media.addEventListener('volumechange', refreshHtml5State);
    }
    setState(wrapper, button, false, true);

    button.addEventListener('click', function (e) {
      e.stopPropagation();
      var isPlaying = type === 'html5' ? !media.paused : wrapper.getAttribute('data-playing') === 'true';
      var isMuted = type === 'html5' ? media.muted : wrapper.getAttribute('data-muted') === 'true';

      if (!isPlaying) {
        userPaused = false;
        play(true); // user gesture: play with sound
      } else if (isMuted) {
        userPaused = false;
        if (type === 'html5') {
          media.muted = false;
        } else {
          play(true);
        }
      } else {
        userPaused = true;
        pause();
      }
    });

    wrapper.addEventListener('click', function (e) {
      if (e.target.closest('.brand-story__video-toggle')) return;
      button.click();
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var isPlaying = type === 'html5' ? !media.paused : wrapper.getAttribute('data-playing') === 'true';
          if (entry.isIntersecting) {
            if (!hasStarted && shouldAutoplay && !userPaused) {
              play(false); // scroll-triggered autoplay must stay muted per browser policy
            } else if (pausedByObserver && !userPaused) {
              play(false);
              pausedByObserver = false;
            }
          } else if (isPlaying) {
            pause();
            pausedByObserver = true;
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(wrapper);
  }

  function initSection(root) {
    root.querySelectorAll('.brand-story__media-wrapper').forEach(initWrapper);
  }

  document.querySelectorAll('[class*="brand-story-"]').forEach(initSection);
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); });
})();
